import React from 'react'
import getUrl from 'front-end-core/core/url'
import { PRECEDENTS_CONTENT } from 'constants/controllers'
import Icon from 'components/shared/Icon'

export default ({ flavour }) => (
  <div className='precedents-view content-view'>
    <nav className='splash' data-help-item='precedentstiles' data-help-position='bottom'>
      <a href={getUrl(PRECEDENTS_CONTENT, { flavour, view: 'browse' })}>Browse precedents <span className='after'><Icon name='icon-chevron-right' /></span></a>
      <a href={getUrl(PRECEDENTS_CONTENT, { flavour, view: 'related' })}>Browse related resources <span className='after'><Icon name='icon-chevron-right' /></span></a>
    </nav>
  </div>
)
